export default "__VITE_ASSET__00de61ab__"